import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { HeaderTooltip } from 'components/Header/HeaderBtn/styles';
import IconFaq from 'components/icons/iconFaq';
import { useTranslationsContext } from 'contexts/translationsContext';
import { TranslateProps } from 'models/props';
import { useIsLessThan } from 'fxs-utils';

import FaqBtnStyles from './styles';

const FaqBtn: React.FC<TranslateProps> = () => {
	const { t } = useTranslationsContext();

	const isLessThan833 = useIsLessThan(833);
	const [showTooltip, setShowTooltip] = useState(null);

	return (
		<>
			<FaqBtnStyles />

			{isLessThan833 ? (
				<Link to={'/faq'} className={'faq-button'}>
					<IconFaq />
					<span>{t('FAQ')}</span>
				</Link>
			) : (
				<Link
					to={'/faq'}
					className={'faq-button'}
					onMouseEnter={() => {
						setShowTooltip(true);
					}}
					onMouseLeave={() => {
						setShowTooltip(false);
					}}
				>
					<IconFaq />
					{showTooltip && (
						<HeaderTooltip>
							<span>FAQ</span>
						</HeaderTooltip>
					)}
				</Link>
			)}
		</>
	);
};

export const MemoFaqBtn = React.memo(FaqBtn);
